import DomElementsBase from "@common/abstracts/DomElementsBase.class";

const SELECTOR_SLIDER = "ul.bxslider";
const SELECTOR_COMPONENT = ".component-quoteCarouselBlock";
const SELECTOR_BTN_NEXT = ".bxNext";
const SELECTOR_BTN_PREV = ".bxPrev";

export default class QuoteCarouselDomElements extends DomElementsBase {
	constructor($module) {
		const selectors = [SELECTOR_SLIDER, SELECTOR_BTN_NEXT, SELECTOR_BTN_PREV];

		super($module, selectors);
	}

	slider() {
		return this.getElement(SELECTOR_SLIDER);
	}

	component() {
		return this.$module.closest(SELECTOR_COMPONENT);
	}

	buttonNext() {
		return this.getElement(SELECTOR_BTN_NEXT);
	}

	buttonPrevious() {
		return this.getElement(SELECTOR_BTN_PREV);
	}

	sliderItemElements() {
		if (!this.$sliderItemelements) {
			this.$sliderItemelements = this.getChildrenByTag(SELECTOR_SLIDER, "li");
		}

		return this.$sliderItemelements;
	}
}
